<template>
  <div
    v-intersect.quiet="{
      handler: onIntersect,
      options: {
        root: null,
        rootMargin: margin,
        threshold: threshold,
      },
    }"
    class="mx-auto"
  >
    <div class="text-center">
      <v-progress-circular
        v-if="isIntersecting && scroll"
        color="primary"
        indeterminate
      >
      </v-progress-circular>
    </div>
  </div>

  <!-- <div
    class="mt-6 mx-auto"
  >
    <div class="text-center">
      <v-progress-circular
        v-if="scroll"
        color="primary"
        indeterminate
      >
      </v-progress-circular>

      <v-btn
        color="primary"
        outlined rounded v-else
        @click="throttle()"
      >
        {{ $t('commons.viewMore') }}
      </v-btn>
    </div>
  </div> -->
</template>
<script>
export default {
  props: {
    margin: String,
    threshold: {
      type: Array,
      default: () => [1.0],
    },
    scroll: {
      type: Boolean,
      // default: () => true,
      default: () => false,
    },
  },
  data: () => ({
    isIntersecting: false,
    throttle: null,
  }),
  created() {
    this.throttle = this.$throttle(() => {
      this.$emit('scrollList');
    }, 200);
  },
  methods: {
    onIntersect(entries) {
      this.isIntersecting = entries[0].isIntersecting;
      if (this.isIntersecting) {
        this.throttle();
      }
    },
  },
};
</script>
